/* import ACTIONS from "../actions"; */

export default function appointmentsReducer(state, action) {
  switch (action.type) {
    default: return state
  }

}